"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withCache = exports.withCachedValueResult = exports.withCachedPromiseResult = exports.buildUniqueKey = exports.isCached = exports.emptyAppCache = exports.removeCache = exports.MAX_TIMEOUT = exports.types = void 0;
var v4_1 = __importDefault(require("uuid/v4"));
var lodash_1 = require("lodash");
var logger_1 = require("../logger");
var app_1 = require("./storage/app");
var window_local_storage_1 = require("./storage/window-local-storage");
/*
 This is a simple impl. of a caching service. We need to review this so we can start caching every api call
and improve app performance. Right now is per requirements basis.
STEPS:
 1- try to get the cache.
 2- if present, check that the data did not expired.
 3- if expired execute the callback and store the result using the key passe. (return this result).
    Store the timestamp of execution.
 4- if not present execute the callback and store the result using the key passed. (return this result).
    Store the timestamp of execution.
 5- Return the value.

 Future improvements:
 1- find a way of getting the last updated date and store it on load of the app. Maybe?. Using app level this wont be needed.
 2- compare the last updated date with the stored one and if it is later update it.
 3- listen to dynamodb changes for data cached and if updated update the cache.
 4- +Current behaviour
 */
exports.types = {
    LOCAL_STORAGE: 'LOCAL_STORAGE',
    APP: 'APP',
};
exports.MAX_TIMEOUT = 1000 * 60 * 60 * 24 * 5; // 5 days max
var getStorage = function (type) {
    if (type === void 0) { type = exports.types.APP; }
    return (type === exports.types.LOCAL_STORAGE ? (0, window_local_storage_1.storage)() : (0, app_1.storage)());
};
var NOT_CACHED = (0, v4_1.default)();
var cacheName = 'APP_CACHE_RESULTS';
var DEFAULT_TIMEOUT = 1000 * 60 * 5; // 5 minutes default caching
var awaitingResolve = {};
var getCache = function (key, _a) {
    var _b = _a === void 0 ? {} : _a, timeout = _b.timeout, type = _b.type, log = _b.log;
    var thisTime = new Date().getTime();
    if (log) {
        logger_1.logger.info("@sendpayments/js-utils/caching", "trying get  ".concat(key, " in @caching service"));
    }
    var mapString = getStorage(type).getItem(cacheName);
    var map = mapString || {};
    if (!map[key] || (map[key] && thisTime - map[key].time >= timeout)) {
        logger_1.logger.info("@sendpayments/js-utils/caching", "\"".concat(key, "\" not present in @caching service or timeout"));
        return NOT_CACHED;
    }
    if (log) {
        logger_1.logger.info("@sendpayments/js-utils/caching", "returning cached value for \"".concat(key, "\", will last: ").concat(map[key].time - timeout, "ms"), map[key].data);
    }
    return map[key].data;
};
var awaitingResult = function (key, p) {
    awaitingResolve[key] = p;
};
var removeAwaitingResult = function (key) {
    delete awaitingResolve[key];
};
var isAwaitingResult = function (key) { return awaitingResolve[key]; };
var setCache = function (key, data, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, type = _c.type;
    var thisTime = new Date().getTime();
    var mapString = getStorage(type).getItem(cacheName);
    var map = mapString || {};
    getStorage(type).setItem(cacheName, __assign(__assign({}, map), (_b = {}, _b[key] = {
        data: data,
        time: thisTime,
    }, _b)));
    logger_1.logger.info("@sendpayments/js-utils/caching", "storing \"".concat(key, "\" in @caching service at ").concat(thisTime), data);
    return data;
};
var removeCache = function (key, _a) {
    var _b = _a === void 0 ? {} : _a, type = _b.type;
    var mapString = getStorage(type).getItem(cacheName);
    var map = mapString || {};
    delete map[key];
    getStorage(type).setItem(cacheName, map);
    logger_1.logger.info("@sendpayments/js-utils/caching", "removing \"".concat(key, "\" from the @caching service"));
};
exports.removeCache = removeCache;
var emptyAppCache = function () {
    getStorage(exports.types.APP).setItem(cacheName, {});
    logger_1.logger.info("@sendpayments/js-utils/caching", "empty app storage");
};
exports.emptyAppCache = emptyAppCache;
var isCached = function (key, _a) {
    var _b = _a === void 0 ? {} : _a, type = _b.type;
    var mapString = getStorage(type).getItem(cacheName);
    var map = mapString || {};
    return !!map[key] && !!map[key].data;
};
exports.isCached = isCached;
var buildUniqueKey = function (name, params) {
    if (params === void 0) { params = {}; }
    return "name:".concat(name, "-").concat((0, lodash_1.sortBy)(Object.entries(params), function (_a) {
        var prop = _a[0];
        return prop;
    })
        .map(function (_a) {
        var prop = _a[0], value = _a[1];
        return "".concat(prop, ":").concat(value);
    })
        .join('-'));
};
exports.buildUniqueKey = buildUniqueKey;
var withCachedPromiseResult = function (key, _a) {
    var _b = _a === void 0 ? {
        timeout: DEFAULT_TIMEOUT,
        type: exports.types.APP,
    } : _a, timeoutProp = _b.timeout, type = _b.type, _c = _b.log, log = _c === void 0 ? true : _c;
    return function (fPromise) { return __awaiter(void 0, void 0, void 0, function () {
        var timeout, value, pExecution, dataResult, data, ex_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (isAwaitingResult(key)) {
                        logger_1.logger.info("@sendpayments/js-utils/caching", "WAITING execution function for \"".concat(key, "\" to promise to be resolved"));
                        return [2 /*return*/, awaitingResolve[key]];
                    }
                    timeout = type === exports.types.LOCAL_STORAGE ? exports.MAX_TIMEOUT : timeoutProp;
                    value = getCache(key, { timeout: timeout, type: type, log: log });
                    if (!(value === NOT_CACHED)) return [3 /*break*/, 2];
                    pExecution = fPromise();
                    // this is for when we have multiple instances trying to access the same promise.
                    // IMPORTANT: review this and use context so we have one store with all the data.
                    awaitingResult(key, pExecution);
                    return [4 /*yield*/, pExecution];
                case 1:
                    dataResult = _a.sent();
                    if (dataResult) {
                        data = setCache(key, dataResult, { type: type });
                        // removing hte reference
                        removeAwaitingResult(key);
                        return [2 /*return*/, data];
                    }
                    return [2 /*return*/, dataResult];
                case 2: return [2 /*return*/, value];
                case 3:
                    ex_1 = _a.sent();
                    logger_1.logger.info("@sendpayments/js-utils/caching", "execution function for \"".concat(key, "\" failed"), ex_1);
                    (0, exports.removeCache)(key, { type: type });
                    removeAwaitingResult(key);
                    throw ex_1;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.withCachedPromiseResult = withCachedPromiseResult;
var withCachedValueResult = function (key, _a) {
    var _b = _a === void 0 ? { timeout: DEFAULT_TIMEOUT, type: exports.types.APP } : _a, timeoutProp = _b.timeout, type = _b.type, _c = _b.log, log = _c === void 0 ? true : _c;
    return function (f) {
        try {
            var timeout = type === exports.types.LOCAL_STORAGE ? exports.MAX_TIMEOUT : timeoutProp;
            var value = getCache(key, { timeout: timeout, type: type, log: log });
            if (value === NOT_CACHED) {
                var dataResult = f();
                if (dataResult) {
                    var data = setCache(key, dataResult, { type: type });
                    return data;
                }
                return dataResult;
            }
            return value;
        }
        catch (ex) {
            logger_1.logger.info("@sendpayments/js-utils/caching", "execution function for \"".concat(key, "\" failed"), ex);
            (0, exports.removeCache)(key, { type: type });
            throw ex;
        }
    };
};
exports.withCachedValueResult = withCachedValueResult;
var withCache = function (key, _a) {
    var _b = _a === void 0 ? { timeout: DEFAULT_TIMEOUT, type: exports.types.APP } : _a, timeoutProp = _b.timeout, type = _b.type, _c = _b.log, log = _c === void 0 ? true : _c;
    return ({
        persist: function (f) {
            try {
                logger_1.logger.info("@sendpayments/js-utils/caching", "saving ".concat(key, " in cache using withCache.set"));
                var dataResult = f();
                var data = setCache(key, dataResult, { type: type });
                return data;
            }
            catch (ex) {
                logger_1.logger.info("@sendpayments/js-utils/caching", "execution function for \"".concat(key, "\" failed"), ex);
                (0, exports.removeCache)(key, { type: type });
                throw ex;
            }
        },
        get: function (value) {
            var timeout = type === exports.types.LOCAL_STORAGE ? exports.MAX_TIMEOUT : timeoutProp;
            if (log) {
                logger_1.logger.info("@sendpayments/js-utils/caching", "getting ".concat(key, " in cache using withCache.get"));
            }
            var result = getCache(key, { timeout: timeout, type: type, log: log });
            if (result === NOT_CACHED) {
                return value;
            }
            return result;
        },
    });
};
exports.withCache = withCache;
//# sourceMappingURL=caching.js.map